import styled, { css } from 'styled-components'

const designerCSS = css`

   .min {
    flex-direction: row;
    display: flex;
    margin: 0 0 10px 0;
    align-items: flex-start;
  }
   fieldset {
    margin: 5px 15px 0 0;
    justify-content: flex-start;
    display: flex;
    flex-direction: column;
    width: fit-content;
  }
   .min fieldset:nth-child(2) {
    margin-right: 0;
  }
   fieldset span {
    font-size: 0.8rem;
    white-space: nowrap;
  }
   strong {
    font-weight: 600;
    font-size: 0.8rem;
    white-space: nowrap;
    padding: 0 4px;
  }
   .cancel_check {
    margin: 0 0 10px 0;
    padding: 5px 0 15px 0;
    justify-content: flex-start;
    display: flex;
    font-size: 0.8rem;
    align-items: center;
    flex-direction: row;
    width: 100%;
    /* border-bottom: 1px solid hsla(0, 0%, 100%, 0.1); */
  }
   /* .cancel_check:last-child {
    border: 10px solid red;
  } */
   input[type='text'] {
    background: var(--input-background);
    padding: 10px 0 10px 16px;
    border-radius: 10px;
    font-size: 0.8rem;
    margin-top: 5px;
    width: fit-content;
    max-width: 150px;
  }
   input[type='text']:disabled {
    cursor: not-allowed;
  }
   input[readonly] {
    background: transparent;
    padding-left: 0;
  }
   input[readonly].tpsl_result_data {
    font-weight: 800;
    max-width: 70px;
  }
   input[readonly].tpsl_result_data.profit {
    color: hsl(126, 100%, 38%);
  }
   input[readonly].tpsl_result_data.loss {
    color: hsla(340, 88%, 46%, 1);
  }
  /*! CSS Used for new profit loss input with wrapper*/
   .input_wrapper input.tpsl_result_data {
    font-weight: 800;
    border-radius: 10px;
    padding: 10px 10px 10px 30px !important;
    position: relative;
    margin: 5px 0 0 0;
  }
   .input_wrapper input.tpsl_result_data.profit {
    color: hsl(126, 100%, 38%);
  }
   .input_wrapper input.tpsl_result_data.loss {
    color: hsla(340, 88%, 46%, 1);
  }
   .input_wrapper {
    position: relative;
    /* margin-top: 5px; */
  }
   .input_wrapper:after {
    position: absolute;
    left: 10px;
    top: calc(50% + 2px);
    transform: translateY(-50%);
    font-size: 0.8rem;
    font-weight: 600;
  }
     .input_wrapper.profit.active:after{
    content: '$';
    color: #de0e54;
  }
   .input_wrapper.profit:after {
    content: '$';
    color: #ffffff5F;
  }
   .input_wrapper.profit.noContent:after {
    content: '';
    color: #00c213;
  }
   .input_wrapper.loss:after {
    content: '$ -';
    color: #de0e54;
  }
   .input_wrapper.loss.noContent:after {
    content: '';
    color: #de0e54;
  }
`
const developerCSS = css``

export const StopLossEditCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`